// extracted by mini-css-extract-plugin
module.exports = {"title":"Search_title__-kOSH","grid":"Search_grid__R2Ti0","hideFirst":"Search_hideFirst__35Fcp","hideSecond":"Search_hideSecond__6gb2q","imageFull":"Search_imageFull__1hzIJ"};